var API_HOME = "/api/";

if (process.env.NODE_ENV == "development") {
    //API_HOME = "http://192.168.1.128:8484/api/";
    //API_HOME = "https://5.161.75.161/api/";
//API_HOME = "https://testsrvr.organictransactiondatabase.com/api/";
    API_HOME = "http://127.0.0.1:8484/api/";
}

const initialState = {
    //GETS
    //GETS
    //GETS
    GET_PRODUCT_BY_NAME: API_HOME + "products/",
    GET_ALL_PRODUCTS: API_HOME + "all-products/",

    GET_PRODUCER_BY_NAME_OR_NOP_ID: API_HOME + "producers/",
    GET_PRODUCER_BY_OP_NAME: API_HOME + "find-nop-users-by-op-name/",
    GET_PRODUCER_BY_NOP_ID: API_HOME + "find-nop-users-by-nop-id/",
    GET_PRODUCER_BY_OP_NAME_BY_CERTIFIER_ID: API_HOME + "find-nop-users-by-op-name-by-certifier-id/",

    GET_CERTIFIER_BY_NAME_OR_NOP_ID: API_HOME + "certifiers/",

    GET_ALL_CERTIFICATES_BY_ALL_OP_ID: API_HOME + "certificates-by-logged-in-user-all-op-id/",
    GET_CERTIFICATE_BY_ID: API_HOME + "certificate/",
    GET_CERTIFICATES_LOGGED_IN_CERTIFIER: API_HOME + "certificates-by-logged-in-certifier-id/",

    GET_BUYER_BY_OP_NAME: API_HOME + "find-nop-users-by-op-name/",
    GET_BUYER_BY_OP_NOP_ID: API_HOME + "find-nop-users-by-nop-id/",

    GET_NOP_USER_BY_NOP_ID: API_HOME + "find-nop-users-by-nop-id/",
    GET_NOP_USER_BY_NAME: API_HOME + "find-nop-users-by-op-name/",

    //Give me all the transactions (sale and purchase) that is send to or from the current user's all op id
    GET_ALL_TRANSACTIONS_BY_USER_ALL_OP_ID: API_HOME + "all-transactions-by-logged-in-user-all-op-id/",
    GET_TRANSACTION_BY_TRANSACTION_ID: API_HOME + "transaction/",

    //Url to check if the given user is logged in on thre backend, it returns the data about the active login
    GET_IF_USER_LOGGED_IN: API_HOME + "users/session/",

    //POSTS
    //POSTS
    //POSTS
    POST_ADD_NEW_CERTIFIER: API_HOME + "certifier/certifier/",
    POST_ADD_NEW_NOP_USER: API_HOME + "users/nop-user-with-admin/",
    POST_ADD_NEW_TRANSACTION: API_HOME + "transaction/",
    POST_ADD_NEW_LAND_RECORD: API_HOME + "land-record/",
    POST_ADD_NEW_CERTIFICATE: API_HOME + "certificate/",

    USER_LOGIN: API_HOME + "session/",

    //PUT
    //PUT
    PUT_UPDATE_USER_PASSWORD: API_HOME + "users/password/",

    //DELETE
    //DELETE
    USER_LOGOUT: API_HOME + "session/"
};

const state = JSON.parse(JSON.stringify(initialState));

const actions = {};

const mutations = {
    resetState() {}
};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
